// extracted by mini-css-extract-plugin
module.exports = {"pin":"Coordinate_pin__1IxsY"};